import React, { useContext, useState } from 'react';
import AIAssistantContext from '../../context/aiassistantcontext';
import { createLessonReviewSession } from '../../api/chat';
import { apiErrorDetails } from '../../api/lessonreview';
import styles from './LessonReview.module.css';

/**
 * Opens a super-admin Livi chat (SYSTEM_WORK) for lesson review — focused on one
 * proposal when `lessonProposalId` is given (Livi opens with a summary and a
 * recommendation), otherwise on the whole queue. `onOpened` lets a drawer close
 * so the chat panel isn't hidden behind it.
 */
export default function ReviewWithLiviButton({ lessonProposalId, label = 'Review with Livi', onOpened }) {
  const { canUseAIAssistant, openChatSession } = useContext(AIAssistantContext);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  if (!canUseAIAssistant) return null;

  async function handleClick() {
    setBusy(true);
    setError(null);
    try {
      const { sessionID, sessionType } = await createLessonReviewSession(lessonProposalId);
      openChatSession(sessionID, { sessionType: sessionType || 'SYSTEM_WORK' });
      if (onOpened) onOpened();
    } catch (err) {
      setError(apiErrorDetails(err, 'The review chat could not be opened.').message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <span className={styles.actionRow}>
      <button type="button" className={styles.secondaryBtn} onClick={handleClick} disabled={busy}>
        {busy ? 'Opening…' : label}
      </button>
      {error ? <span className={styles.fieldError} role="alert">{error}</span> : null}
    </span>
  );
}
